module.exports = __webpack_public_path__ + "img/resized-cover1.34bb1674.png";